import { Icon, IconName, IconProps } from '@ardoq/icons';
import { Button } from './Button';
import { ButtonProps, ButtonType } from './types';
import { Ref } from 'react';

export type IconButtonProps = ButtonProps & {
  /**
   * Sets aria-label and tooltip text
   */
  label: string;
  iconName: IconName;
  iconColor?: IconProps['color'];
  ref?: Ref<HTMLButtonElement>;
  /** @deprecated Use 'label' instead. */
  'data-tooltip-text'?: string;
};

/**
 * Please provide label for this button
 */
export const IconButton = ({
  iconName,
  iconColor,
  label,
  ...buttonProps
}: IconButtonProps) => (
  <Button
    buttonType={ButtonType.GHOST}
    {...buttonProps}
    aria-label={label}
    data-tooltip-text={label}
  >
    <Icon iconName={iconName} color={iconColor} />
  </Button>
);
